import React, { Component } from 'react';
import rootStore from "./store/store";
import { Provider } from "react-redux";
import MessengerCustomerChat from 'react-messenger-customer-chat';
import CookieConsent from "react-cookie-consent";

/* import containers */
import HomeContainer from './container/public/HomeContainer';
import TeamContainer from './container/public/TeamContainer';
import BlogContainer from './container/public/BlogContainer';
import ImpressumContainer from './container/public/ImpressumContainer';
import AGBContainer from './container/public/AGBContainer';
import DatenschutzContainer from './container/public/DatenschutzContainer';
import PatientsContainer from './container/public/PatientsContainer';
import PricingContainer from './container/public/PricingContainer';
import SearchContainer from './container/public/SearchContainer';
import IframeContainer from './container/public/IframeContainer';
import DetailContainer from './container/public/DetailContainer';
import Error404Container from './container/public/Error404Container';
import LoginContainer from './container/public/LoginContainer';
import AdminContainer from './container/doctor/AdminContainer';
import SettingsContainer from './container/doctor/SettingsContainer';
import ContactContainer from './container/public/ContactContainer';
import ApiUIHandler from './container/ApiUIHandler';

/* import components */
import PublicHeader from './components/PublicHeader/PublicHeader';
import PublicFooter from './components/PublicFooter/PublicFooter';
import ScrollToTop from './components/ScrollToTop/ScrollToTop'

import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
  withRouter,
  Link
} from 'react-router-dom'
import PrivateHeader from "./components/PrivateHeader/PrivateHeader";
import DoctorsContainer from "./container/public/DoctorsContainer";
import BlogDetailContainer from './container/public/BlogDetailContainer';
import RegisterContainer from './container/public/RegisterContainer';
import RegisterSuccessContainer from './container/public/RegisterSuccessContainer';
import RegisterVerifiedContainer from './container/public/RegisterVerifiedContainer';

const fakeAuth = {
  isAuthenticated: true,
  authenticate(cb) {
    this.isAuthenticated = true;
    setTimeout(cb, 100); // fake async
  },
  signout(cb) {
    this.isAuthenticated = false;
    setTimeout(cb, 100);
  }
};

function PrivateRoute({ component: Component, ...rest }) {
  const token = localStorage.getItem('authToken');

  return (
    <Route
      {...rest}
      render={props =>
        token !== null ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}

const PublicHeaderRouter = withRouter(PublicHeader);
const PrivateHeaderRouter = withRouter(PrivateHeader);

class App extends Component {

  constructor(props) {
    super(props);

    this.handleScroll = this.handleScroll.bind(this);

    this.state = {
      scrolledDown: false
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if ((window.pageYOffset > 0 || document.documentElement.scrollTop > 0 && this.state.scrolledDown === false)) {
      this.setState({ scrolledDown: true });
    } else if (document.documentElement.scrollTop === 0 && this.state.scrolledDown === true) {
      this.setState({ scrolledDown: false });
    }
  }

  render() {

    return (
      <Router>
        <ScrollToTop>
          <Provider store={rootStore}>
            <div>
              <Switch>
                <Route path={'/dashboard'}>
                  <div>
                    <PrivateHeaderRouter />
                    <Switch>
                      <PrivateRoute path="/dashboard/profile" component={DetailContainer} />
                      <PrivateRoute path="/dashboard/settings" component={SettingsContainer} />
                      <PrivateRoute path="/dashboard" component={AdminContainer} />
                    </Switch>
                    <PublicFooter />
                  </div>
                </Route>

                <Route path={'/iframe'}>
                  <div>
                    <Switch>
                      <Route path="/iframe/termin/:id" component={DetailContainer} />
                      <Route path="/iframe/:code/:values" component={IframeContainer} />
                      <Route path="/iframe/:code" component={IframeContainer} />
                    </Switch>

                    <PublicFooter iframe />
                    <CookieConsent
                      buttonText="Einverstanden"
                      containerClasses="cookies-law"
                      buttonClasses="btn"
                      disableButtonStyles
                    >
                      Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. Durch die weitere Nutzung der Webseite stimmen Sie der Verwendung von Cookies zu.

                      Weitere Informationen zu Cookies erhalten Sie in unserer <Link to="/datenschutz">Datenschutzerklärung</Link>
                    </CookieConsent>

                  </div>
                </Route>

                <Route path={'/'}>
                  <div>
                    <PublicHeaderRouter scrolled={this.state.scrolledDown} />

                    <Switch>
                      <Route path="/" exact component={HomeContainer} />
                      <Route path="/search/:what/:where/:when" component={SearchContainer} />
                      <Route path="/patient" component={PatientsContainer} />
                      <Route path="/doktor" component={DoctorsContainer} />
                      <Route path="/team" component={TeamContainer} />
                      <Route path="/pricing" component={PricingContainer} />
                      <Route path="/kontakt" component={ContactContainer} />
                      <Route path="/impressum" component={ImpressumContainer} />
                      <Route path="/agb" component={AGBContainer} />
                      <Route path="/datenschutz" component={DatenschutzContainer} />
                      <Route path="/suchergebnisse" component={HomeContainer} />
                      <Route path="/termin/:id" component={DetailContainer} />
                      <Route path="/blog/:articleID" component={BlogDetailContainer} />
                      <Route path="/blog" component={BlogContainer} />
                      <Route path="/login" component={LoginContainer} />
                      <Route path="/register" component={RegisterContainer} />
                      <Route path="/registerSuccess" component={RegisterSuccessContainer} />
                      <Route path="/emailverified" component={RegisterVerifiedContainer} />
                      <PrivateRoute path="/protected" component={DetailContainer} />
                      <Route component={Error404Container} />
                    </Switch>

                    <PublicFooter />
                    <CookieConsent
                      buttonText="Einverstanden"
                      containerClasses="cookies-law"
                      buttonClasses="btn"
                      disableButtonStyles
                    >
                      Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. Durch die weitere Nutzung der Webseite stimmen Sie der Verwendung von Cookies zu.

                      Weitere Informationen zu Cookies erhalten Sie in unserer <Link to="/datenschutz">Datenschutzerklärung</Link>
                    </CookieConsent>

                  </div>
                </Route>
              </Switch>
              <ApiUIHandler />
            </div>
          </Provider>
        </ScrollToTop>

      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js